var map = {
	"./favicon.ico": 1479,
	"./logo-beatz.png": 4925,
	"./logo-empresa.png": 2217,
	"./logo-footer.svg": 4605,
	"./logo-link.svg": 3348,
	"./logo.png": 6700,
	"./logo.svg": 2363,
	"./parceiros/baladapp.png": 2467,
	"./parceiros/barradao.png": 7284,
	"./parceiros/icone-generico.png": 1039,
	"./parceiros/independencia.png": 1325,
	"./parceiros/mineirao.png": 1956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7434;